import type { Variant } from '../models/product/dto/variant';
import type { LocationPriceStream } from '../models/enum/shared/location-price-stream';

/**
 * Utils files are made to stop circular imports between files that would otherwise occur.
 * They should contain only static methods and no state.
 */
export class VariantUtils {
  public static groupVariantsBySameSizeQuantityAndPrice(
    variantsToDisplay: Variant[],
    themeId: string,
    locId: number,
    companyId: number | null,
    priceStream: LocationPriceStream,
    hideSale: boolean
  ): Variant[][] {
    const chunkedByQuantityAndPrice = new Map<string, Variant[]>();
    variantsToDisplay?.forEach(variant => {
      const price = variant?.getVisiblePrice(themeId, locId, companyId, priceStream, hideSale);
      const unitSize = variant?.getFormattedUnitSize();
      const packagedQuantity = variant?.packagedQuantity;
      const key = `${price}|${unitSize}|${packagedQuantity}`;
      if (!chunkedByQuantityAndPrice.has(key)) {
        chunkedByQuantityAndPrice.set(key, []);
      }
      chunkedByQuantityAndPrice.get(key)?.push(variant);
    });
    return [...(chunkedByQuantityAndPrice.values() || [])];
  }
}
